import { useState } from 'react'

import { API_ENDPOINT } from '../consts'

function useRecruiteeForm({ offer, reset }) {
  const [isSuccess, setSuccess] = useState(false)
  const [error, setError] = useState('')

  const onSubmit = async data => {
    try {
      const formData = new FormData()
      for (const [k, v] of Object.entries(data.candidate)) {
        formData.append(`candidate[${k}]`, v)
      }

      formData.append('candidate[name]', `${data.firstName} ${data.lastName}`)

      formData.append('candidate[cv]', data.cv[0])

      // open Question Answers

      const responses = data.questions

      for (let i = 0; i < offer.open_questions.length; i++) {
        const question = offer.open_questions[i]
        const response = responses[question.id]

        formData.append(
          `candidate[open_question_answers_attributes][${i}][open_question_id]`,
          question.id
        )

        switch (question.kind) {
          case 'boolean':
          case 'legal':
            formData.append(
              `candidate[open_question_answers_attributes][${i}][flag]`,
              response === null ? '' : response
            )
            break
          case 'single_choice':
            formData.append(
              `candidate[open_question_answers_attributes][${i}][content]`,
              response?.value || ''
            )
            break
          // TODO: fix multi choice in recruitee
          case 'multi_choice':
            if (Array.isArray(response)) {
              for (let j = 0; j < response.length; j++) {
                formData.append(
                  `candidate[open_question_answers_attributes][${i}][multi_content][${j}]`,
                  response[j]?.value || ''
                )
              }
            }
            break
          case 'file':
            formData.append(
              `candidate[open_question_answers_attributes][${i}][file]`,
              response[0]
            )
            break
          default:
            formData.append(
              `candidate[open_question_answers_attributes][${i}][content]`,
              response
            )
        }
      }

      const options = {
        body: formData,
        method: 'POST',
      }

      const url = `${API_ENDPOINT}/offers/${offer.slug}/candidates`

      const res = await fetch(url, options)
      if (!res.ok) {
        setError(`${res.status}: ${res.statusText}`)
      } else {
        setSuccess(true)
        reset({})
      }

      /* eslint-disable */
    } catch (e) {
      setError('Client-side error')
    }
  }

  return {
    isSuccess,
    error,
    onSubmit,
  }
  
}

export default useRecruiteeForm

